var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalRespon",
    attrs: {
      "id": "modal-billing",
      "title": "Rekam Bukti Bayar",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [_c('b-form-fieldset', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("No. NTPN / Bukti Bayar")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.no_ntpn),
      callback: function($$v) {
        _vm.no_ntpn = $$v
      },
      expression: "no_ntpn"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tanggal NTPN / Bukti Bayar")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "date",
      "required": ""
    },
    model: {
      value: (_vm.tgl_ntpn),
      callback: function($$v) {
        _vm.tgl_ntpn = $$v
      },
      expression: "tgl_ntpn"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'FILE_NTPN'); }
    }
  }), _vm._v(" "), (!this.$store.state.barpin.files.FILE_NTPN) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n        Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "submit",
      "variant": "success"
    }
  }, [_vm._v("Simpan")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670588bc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/modal/ModalBilling.vue
// module id = 379
// module chunks = 0